export { InternalMessageBusChannels } from "./InternalMessageBus";
import * as mbus from "./InternalMessageBus";
export const internalMessageBus = new mbus.InternalMessageBus();
//# sourceMappingURL=index.js.map